import { useMemo } from "react";
import Typography from "../Typography";
import Dropdown from "../Dropdown/Dropdown";
import Pagination from "./Pagination";
import { LIST_PAGE_SIZE_OPTIONS } from "./listPaginationConstants";

/**
 * List footer: rows-per-page (left) + page controls (right when multiple pages).
 */
const ListPaginationBar = ({
  currentPage = 1,
  totalPages = 1,
  pageSize = 25,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = LIST_PAGE_SIZE_OPTIONS,
  className = "",
}) => {
  const showPager = totalPages > 1;

  const pageSizeDropdownOptions = useMemo(
    () => pageSizeOptions.map((size) => ({ value: String(size), label: String(size) })),
    [pageSizeOptions]
  );

  return (
    <div
      className={`mt-3 flex flex-wrap items-center gap-3 ${showPager ? "justify-between" : "justify-start"} ${className}`.trim()}
      data-testid="list-pagination-bar"
    >
      <div className="flex items-center gap-2 shrink-0">
        <Typography
          variant="text2"
          component="span"
          className="text-text-secondary whitespace-nowrap"
        >
          Rows per page
        </Typography>
        <Dropdown
          name="list-page-size"
          value={String(pageSize)}
          onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
          options={pageSizeDropdownOptions}
          placeholder="25"
          searchable={false}
          clearable={false}
          preserveOptionOrder={true}
          noWrapper={true}
          className="w-[5.25rem] shrink-0 text-sm [&_input]:!h-8 [&_input]:!min-h-8 [&_input]:!py-1.5"
        />
      </div>
      {showPager ? (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          className="!mt-0 shrink-0"
        />
      ) : null}
    </div>
  );
};

export default ListPaginationBar;
